import * as React from "react";

type IContainerProps<TContainerProps> = IBaseContainerProps<TContainerProps> & TContainerProps;

export interface IBaseContainerProps<TContainerProps> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: (props: TContainerProps) => any;
}

export function generateBaseContainer<TContainerProps>(): React.FC<IContainerProps<TContainerProps>> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props): any => props.children(props);
}
